import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { Eye, EyeOff } from 'lucide-react';

function Login({ onSwitch }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const handleLogin = async () => {
    setError('');
    if (!email.includes('@')) return setError('Enter a valid email');
    if (!password) return setError('Enter your password');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onSwitch('pin-login');
    } catch (e) {
      setError('Incorrect email or password');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-5">
      <div className="bg-gray-900 border border-gray-800 rounded-2xl p-7 w-full max-w-sm relative">

        <button
          onClick={() => onSwitch('landing')}
          className="absolute top-4 right-4 text-gray-600 hover:text-white transition-all text-lg">
          ✕
        </button>

        <div className="flex items-center gap-2 mb-6">
          <svg width="26" height="26" viewBox="0 0 100 130" fill="none">
            <defs>
              <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#f2c832"/>
                <stop offset="100%" stopColor="#e8496a"/>
              </linearGradient>
            </defs>
            <path d="M58 4L84 4L84 10L68 10L68 54L84 54L84 62L52 126L42 126L62 72L44 72L44 62L16 62L16 54L32 54L32 10L16 10L16 4L42 4L42 54L58 54Z" fill="url(#lg)"/>
          </svg>
          <span className="font-bold text-sm bg-gradient-to-r from-yellow-400 to-pink-500 bg-clip-text text-transparent">ArcBolt</span>
        </div>

        <h2 className="text-xl font-bold text-white mb-1">Welcome back</h2>
        <p className="text-xs text-gray-500 mb-6">Sign in to your account</p>

        <div className="mb-4">
          <label className="text-xs text-gray-500 uppercase tracking-wide mb-1 block">Email</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="w-full bg-gray-950 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-yellow-500 transition-all placeholder-gray-700"
          />
        </div>

        <div className="mb-2">
          <label className="text-xs text-gray-500 uppercase tracking-wide mb-1 block">Password</label>
          <div className="relative">
            <input
              type={showPw ? 'text' : 'password'}
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Your password"
              className="w-full bg-gray-950 border border-gray-700 rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-yellow-500 transition-all placeholder-gray-700 pr-10"
            />
            <button onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300">
              {showPw ? <EyeOff size={16}/> : <Eye size={16}/>}
            </button>
          </div>
        </div>

        <div className="text-right mb-5">
          <span onClick={() => onSwitch('forgot')} className="text-xs text-yellow-400 cursor-pointer hover:underline">Forgot password?</span>
        </div>

        {error && <div className="bg-red-950 border border-red-800 rounded-lg px-3 py-2 text-xs text-red-400 mb-4">{error}</div>}

        <button
          onClick={handleLogin}
          disabled={loading}
          className="w-full bg-gradient-to-r from-yellow-500 to-pink-600 text-white font-semibold py-2.5 rounded-lg text-sm hover:opacity-90 transition-all disabled:opacity-40"
        >
          {loading ? 'Signing in...' : 'Sign in'}
        </button>

        <p className="text-xs text-gray-600 text-center mt-4">
          No account?{' '}
          <span onClick={() => onSwitch('signup')} className="text-yellow-400 cursor-pointer hover:underline">Create one</span>
        </p>

      </div>
    </div>
  );
}

export default Login;